import { WarrantyKanbanBoard } from '@components/WarrantyKanban/WarrantyKanbanBoard';
import { Dialog, DialogContent } from '@shadcn/components/ui/dialog';
import { useTaskCard } from '@zustand/useTaskCard';
import moment from 'moment';
import { Badge } from '@shadcn/components/ui/badge';
import { CalendarDays, User, AlertTriangle, PackageCheck, Truck, ArrowRight, History, Store, Clock, Package } from 'lucide-react';
import { InfoBox } from '@shadcn/components/ui/infobox';
import { states, FAULT_REASONS } from './warranty-claim';
import { Button } from '@shadcn/components/ui/button';
import { Link } from 'react-router-dom';
import { CloseTicketButton } from '@components/shared/CloseTicketButton';
import ExportRecentButton from '@components/shared/ExportRecentButton';
import { useState, useEffect } from 'react';
import { useQueryParams } from '@helpers/JIFI/useQueryParams';
import superagent from 'superagent';
import { backendUrl } from '@helpers/consts';

export const getLabel = (list, value) => {
  const item = list.find((item) => item.value === value);
  return item ? item.label : value;
};

export const getShortLabel = (list, value) => {
  const item = list.find((item) => item.value === value);
  return item ? (item.shortLabel || item.label) : value;
};

export const HeicImage = ({ url, alt, className }) => {
  const [imgSrc, setImgSrc] = useState(url);
  const [error, setError] = useState(false);

  // Auto attempt to convert heic to jpg
  useEffect(() => {
    if (url?.toLowerCase().includes('.heic')) {
      setImgSrc(url.replace(/\.heic$/i, '.jpg'));
    }
  }, [url]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onError={() => {
        if (!error) {
          setError(true);
          setImgSrc(url); // fallback to original
        }
      }}
    />
  );
};

const WarrantyClaimPage = () => {
  const selected = useTaskCard((state) => state.selected);
  const card = useTaskCard((state) => state.task);
  const selectedCard = useTaskCard((state) => state.selectedCard);
  const setSelected = useTaskCard((state => state.setSelected))
  
  
  const queryParams = useQueryParams();
  const id = queryParams.get('id');
  
  
 
  
  useEffect(() => {
    if (id && !selected && !card ) {
      fetchCardById(id);
    }
  }, [id, selected, card]);

  
  const fetchCardById = async (cardId) => {
    try {
      
      const response = await superagent
        .get(`${backendUrl}/warranty-tickets/${cardId}`)
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('Accept', 'application/json');
      
      if (response.body) {
        const cardData = {
          id: response.body._id,
          ...response.body
        };
        
        
        selectedCard(cardData);
        setSelected(true)
      }
    } catch (err) {
      console.error('Error fetching card by ID:', err);
    } 
  };

  
  
  
  
  return (
    <div className="container mx-auto px-4 flex flex-col nguyen441">
      <div className="flex justify-end gap-2">
        <ExportRecentButton ticketType="warranty" />
        <a href="/warranty-claim">
          <Button className="mb-4">
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="mr-2"
            >
              <path d="M12 5v14M5 12h14" />
            </svg>
            New Warranty</Button>
        </a>
      </div>
      <div className="overflow-hidden">
        <WarrantyKanbanBoard/>
      </div>
      <Dialog open={selected} onOpenChange={() => {
        selectedCard({})
        setSelected(false)
      }}>
        <DialogContent hideClose className="z-[1600] max-h-[80vh] overflow-y-auto min-w-[60vw]">
          <div className="grid grid-cols-1 gap-8">
            <div className="space-y-6">
              <div className="border-b pb-4 flex justify-between items-start">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                    <span>Warranty Claim {card?.order?.name && <Link to={`/orders/${card?.order?._id}`}>{card?.order?.name}</Link>}</span>
                    {!card?.hasOrder && (
                      <>
                      {card?.orderNumber && <Badge variant="outline" className="text-sm bg-gray-100 text-gray-800">
                        {card?.orderNumber}
                      </Badge>} 
                      <Badge variant="outline" className="text-sm bg-gray-100 text-gray-800">
                        Pre 2020
                      </Badge>
                     
                      </>
                    )}
                                            <Badge variant="outline" className="text-sm bg-gray-100 text-gray-800">
                      {card?.fulfilled ? "Fulfilled" : "Processing"}
                    </Badge>
                  </h2>
                  <div className="mt-2 flex items-center gap-2 text-sm text-gray-500">
                    <CalendarDays className="h-4 w-4" />
                    <span>Created at: {moment(card?.createdAt).format('DD/MM/YYYY HH:mm')}</span>
                  </div>
                </div>
                <div className="flex gap-2">
      {!card?.closedAt ?   (
      <CloseTicketButton 
        ticketId={card?._id}
        ticketType="warranty"
        onSuccess={() => {
          selectedCard({})
          setSelected(false)
        }}
      />
    ) : (
      <CloseTicketButton
        ticketId={card?._id}
        ticketType="warranty"
        onSuccess={() => {
          selectedCard({})
          setSelected(false)
        }}
        isReOpen={true}
      />
    )}
      <Button 
        variant="ghost" 
        size="sm"
        onClick={() => {
          selectedCard({})
          setSelected(false)
        }}
        className="text-gray-500 hover:text-gray-700"
      >
        ✕
      </Button>
    </div>
              </div>

              
              <div className="space-y-4">
                <h3 className="text-lg font-semibold flex items-center gap-2">
                  <User className="h-5 w-5" />
                  Customer Information
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  <InfoBox label="Customer Name" value={card?.customerName} />
                  <InfoBox label="Batch Code" value={card?.batchCode} />
                  <InfoBox
                    label="State"
                    value={getLabel(states, card?.state)}
                  />
                  <InfoBox label="Store Location" value={card?.store?.display_name} />
                  <InfoBox label="Staff Member" value={card?.retailMemberName} />

                </div>
              </div>

             
              <div className="space-y-4">
                <h3 className="text-lg font-semibold flex items-center gap-2">
                  <AlertTriangle className="h-5 w-5 text-red-500" />
                  Warranty Reason
                </h3>
                
                
                <div className="space-y-2">
                  <div className="p-4 bg-red-50 rounded-lg">
                    <div className="font-medium text-red-700">Customer Request:</div>
                    <p className="mt-2 text-sm text-red-600">
                      {card?.customerRequest || 'No special request'}
                    </p>
                  </div>
                  
                  <div className="p-4 bg-yellow-50 rounded-lg">
                    <div className="font-medium text-yellow-800">Fault Reason:</div>
                    <p className="mt-2 text-sm text-yellow-700">
                      {getLabel(FAULT_REASONS, card?.faultReason)}
                    </p>
                  </div>
                </div>
              </div>

              
              {card?.replacementSkus?.length > 0 && (
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold flex items-center gap-2">
                                            <PackageCheck className="h-5 w-5 text-gray-700" />
                    Replacement Items
                  </h3>
                  
                  <div className="space-y-4">
                    {card.replacementSkus.filter(replacement => replacement !== null).map((item, index) => (
                      <div key={index} className="bg-gray-50 p-6 rounded-lg border border-gray-200 shadow-sm">
                        
                        <div className="flex items-center gap-2 mb-4">
                          <Package className="h-5 w-5 text-gray-600" />
                          <div className="flex items-center gap-2 text-sm">
                            <span className="text-gray-500 line-through font-medium bg-gray-100 px-2 py-1 rounded">
                              {item?.originalSku}
                            </span>
                            <ArrowRight className="h-4 w-4 text-gray-400" />
                            <span className="font-semibold text-gray-900 bg-gray-200 px-2 py-1 rounded">
                              {item?.replacementSku}
                            </span>
                          </div>
                        </div>

                        
                        <div className="mb-4 p-4 bg-white rounded-lg border border-gray-200">
                          <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                            <Truck className="h-4 w-4" />
                            Delivery Options
                          </h4>
                          <div className="flex flex-wrap gap-2">
                            {item?.toBeShipped ? (
                                                          <div className="flex items-center gap-2 bg-gray-100 px-3 py-2 rounded-full">
                              <Truck className="h-4 w-4 text-gray-600" />
                              <span className="text-sm text-gray-700 font-medium">Ship to Customer</span>
                              </div>
                            ) : item?.pickupLocation ? (
                              <div className="flex items-center gap-2 bg-gray-200 px-3 py-2 rounded-full">
                                <Store className="h-4 w-4 text-gray-700" />
                                <span className="text-sm text-gray-800 font-medium">
                                  Pickup at {item.pickupLocation?.display_name}
                                </span>
                                <Badge variant="outline" className="text-xs bg-white">
                                  {item.pickupLocation?.code}
                                </Badge>
                              </div>
                            ) : (
                              <div className="flex items-center gap-2 bg-gray-100 px-3 py-2 rounded-full">
                                <Store className="h-4 w-4 text-gray-500" />
                                <span className="text-sm text-gray-600">No delivery option set</span>
                              </div>
                            )}
                          </div>

                          {/* Date Needed By */}
                          {item.dateNeededBy && (
                            <div className="mt-3 flex items-center gap-2 bg-yellow-50 px-3 py-2 rounded-lg border border-yellow-200">
                              <Clock className="h-4 w-4 text-yellow-600" />
                              <span className="text-sm text-yellow-800">
                                <span className="font-medium">Needed by:</span>{' '}
                                {moment(item.dateNeededBy).format('DD MMM YYYY')}
                              </span>
                            </div>
                          )}
                        </div>

                       

                        {item?.monogram && Array.isArray(item.monogram) && (
                        item.monogram?.filter(monogram => monogram !== null).map((monogram, index) => (  
                                                    <div className="p-3 bg-gray-100 rounded-lg border border-gray-300">
                            <h4 className="text-sm font-semibold text-gray-800 mb-2">Personalization</h4>
                            <div className="text-sm text-gray-700">
                                                      <span className="font-medium">Text:</span> {monogram.text} <br />
                                                      <span className="font-medium">Font:</span> {monogram.font} <br />
                                                      <span className="font-medium">Color:</span> {monogram.color} <br />
                                                      <span className="font-medium">Location:</span> {monogram.location}
                                                    </div>
                                                  </div>
                        ))
                          
                        )}

                        {item.monogram && !Array.isArray(item.monogram) && (
                          <div className="p-3 bg-gray-100 rounded-lg border border-gray-300">
                            <h4 className="text-sm font-semibold text-gray-800 mb-2">Personalization</h4>
                            <div className="text-sm text-gray-700">
                              <span className="font-medium">Text:</span> {item?.monogram?.text} <br />
                              <span className="font-medium">Font:</span> {item?.monogram?.font} <br />
                              <span className="font-medium">Color:</span> {item?.monogram?.color} <br />
                              <span className="font-medium">Location:</span> {item?.monogram?.location}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}


              <div className="space-y-4">
                <h3 className="text-lg font-semibold flex items-center gap-2">
                                        <Truck className="h-5 w-5 text-gray-700" />
                  Shipping Information
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  <InfoBox 
                    label="Primary Shipping Method" 
                    value={card?.toBeShipped ? "Shipping" : card?.pickupLocation?.display_name}  
                    icon={<Truck className="h-4 w-4" />}
                  />
                  {card?.replacementIssuedDate && (
                    <InfoBox 
                      label="Replacement Date" 
                      value={moment(card.replacementIssuedDate).format('DD/MM/YYYY')}
                      icon={<CalendarDays className="h-4 w-4" />}
                    />
                  )}
{card?.originalOrderDate && (
                  <InfoBox 
                  label="Original Order Date" 
                  value={card?.originalOrderDate ? moment(card.originalOrderDate).format('DD/MM/YYYY') : 'N/A'} 
                  icon={<History className="h-4 w-4" />}
                />
              )}
                </div>
              </div>

              {card?.attachments && card.attachments.length > 0 && (
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold">Warranty Images</h3>
                  <div className="grid grid-cols-2 gap-4">
                    {card.attachments.map((url, index) => (
                      <HeicImage
                        key={index}
                        url={url}
                        alt={`Warranty image ${index + 1}`}
                        className="rounded-lg object-cover w-full h-48"
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default WarrantyClaimPage;
